// extracted by mini-css-extract-plugin
module.exports = {"reasonsToOutsourceItem":"ReasonsToOutsourceItem_reasonsToOutsourceItem__vAYvV","reasonsToOutsourceItem__main":"ReasonsToOutsourceItem_reasonsToOutsourceItem__main__lhSbk"};